export const encouragementText = "Here's some words of encouragement to brighten your day!";
export const feedbackText = "Here's a blast from the past to brighten your day!";
